import disable from "./ga-disable";

export default () => {
  disable(false);
};
